import { render } from "./NavBar.vue?vue&type=template&id=612a6734"
import script from "./NavBar.vue?vue&type=script&lang=ts"
export * from "./NavBar.vue?vue&type=script&lang=ts"
script.render = render

export default script